"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var ApplicationEmbed_meta_1 = require("./ApplicationEmbed.meta");

var ApplicationEmbed =
/** @class */
function (_super) {
  __extends(ApplicationEmbed, _super);

  function ApplicationEmbed(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = ApplicationEmbed_meta_1.APPLICATION_EMBED_CATEGORY_KEY;
    _this.componentKey = ApplicationEmbed_meta_1.APPLICATION_EMBED_COMPONENT_KEY;

    _this.appendCacheOptionsQueryString = function (url, cacheOptions) {
      var response = url;

      if (typeof cacheOptions === 'object') {
        var separator = url.includes('?') ? '&' : '?';
        var key = 'cache';
        response += "" + separator + key + "=" + JSON.stringify(cacheOptions);
      }

      return response;
    };

    _this.joinPath = function (pieces) {
      return pieces.map(function (piece) {
        var cleanPiece = piece;

        while (cleanPiece.startsWith('/')) {
          cleanPiece = cleanPiece.substr(1);
        }

        while (cleanPiece.endsWith('/')) {
          cleanPiece = cleanPiece.substr(0, cleanPiece.length - 1);
        }

        return cleanPiece;
      }).join('/');
    };

    _this.appLoadCallback = function () {
      var onLoad = _this.props.onLoad;

      if (onLoad && _this.embedTarget) {
        onLoad(_this.embedTarget);
      }
    };

    _this.attachListeners = function (element) {
      var loadEventName = 'ksys-app-loaded';
      element.removeEventListener(loadEventName, _this.appLoadCallback);
      element.addEventListener(loadEventName, _this.appLoadCallback);
    };

    _this.getInputKey = function (rawKey) {
      var key = rawKey;

      if (key.length > 1) {
        var firstLetter = key[0];
        var firstLetterUpper = firstLetter.toUpperCase();

        if (firstLetter !== firstLetterUpper) {
          key = [firstLetterUpper, key.substr(1)].join('');
        }
      } else {
        key = key.toUpperCase();
      }

      return "input" + key;
    };

    _this.wrapperRef = react_1.default.createRef();
    return _this;
  }

  Object.defineProperty(ApplicationEmbed.prototype, "embedTarget", {
    get: function get() {
      if (this.wrapperRef) {
        var wrapper = this.wrapperRef.current;

        if (wrapper && wrapper.children && wrapper.children.length > 0) {
          return wrapper.children[0];
        }
      }

      return undefined;
    },
    enumerable: true,
    configurable: true
  });

  ApplicationEmbed.prototype.initialize = function () {
    var embedTarget = this.embedTarget;

    if (!embedTarget) {
      return;
    }

    this.attachListeners(embedTarget);
    var browserWindow = window;

    if (browserWindow && browserWindow.ksysAddEmbeddedApps) {
      browserWindow.ksysAddEmbeddedApps({
        hostname: this.props.hostname
      });
    } else {
      // SCRIPT LOADING
      var hasManager = document.querySelectorAll('[data-ksys-app-template-id="ksys-app-manager"]').length > 0;

      if (!hasManager) {
        var _a = this.props,
            templateId = _a.templateId,
            applicationCode = _a.applicationCode,
            hostname = _a.hostname,
            cacheOptions = _a.cacheOptions;

        if (applicationCode && hostname) {
          var src = this.joinPath([hostname, 'applicationManager', 'apps', applicationCode, "main-" + templateId + ".js"]);
          var scriptExists = document.querySelector('script[src|="' + src + '"]');

          if (!scriptExists) {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = this.appendCacheOptionsQueryString(src, cacheOptions);
            document.body.appendChild(script);
          }
        }
      } // TRIGGER EVENT


      var _b = this.props.eventName,
          eventName = _b === void 0 ? 'ksys-app-embed-added' : _b;

      if (browserWindow && browserWindow['ksysTriggerEvent']) {
        browserWindow['ksysTriggerEvent'](eventName, embedTarget);
      }
    }
  };

  ApplicationEmbed.prototype.componentDidMount = function () {
    this.initialize();
  };

  ApplicationEmbed.prototype.componentDidUpdate = function (prevProps, prevState) {
    this.initialize();
  };

  ApplicationEmbed.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        embedClassName = _a.embedClassName,
        templateId = _a.templateId,
        version = _a.version,
        applicationCode = _a.applicationCode,
        _b = _a.configurationKey,
        configurationKey = _b === void 0 ? 'default' : _b,
        _c = _a.themeKey,
        themeKey = _c === void 0 ? 'default' : _c,
        _d = _a.styleKey,
        styleKey = _d === void 0 ? 'default' : _d,
        _e = _a.inputs,
        inputs = _e === void 0 ? [] : _e,
        _f = _a.tag,
        tag = _f === void 0 ? 'div' : _f,
        embedId = _a.embedId;

    if (!templateId) {
      return null;
    }

    var child = document.createElement(tag);

    if (embedClassName) {
      child.className = embedClassName;
    }

    child.dataset.ksysAppTemplateId = templateId;

    if (version) {
      child.dataset.ksysAppTemplateVersion = version;
    }

    if (applicationCode) {
      child.dataset.applicationCode = applicationCode;
    }

    child.dataset.configurationKey = configurationKey;
    child.dataset.styleKey = styleKey;
    child.dataset.themeKey = themeKey;

    if (embedId) {
      child.dataset.embedId = embedId;
    }

    inputs.forEach(function (input) {
      var rawKey = input.key,
          value = input.value;

      if (rawKey) {
        var inputKey = _this.getInputKey(rawKey);

        child.dataset[inputKey] = value;
      }
    });
    var inputKeys = Object.keys(this.props).filter(function (key) {
      return key.startsWith('input') && key !== 'inputs';
    });

    if (inputKeys && inputKeys.length > 0) {
      inputKeys.forEach(function (inputKey) {
        child.dataset[inputKey] = _this.props[inputKey];
      });
    }

    return react_1.default.createElement("div", {
      ref: this.wrapperRef,
      className: className,
      dangerouslySetInnerHTML: {
        __html: child.outerHTML
      }
    });
  };

  ApplicationEmbed = __decorate([mobx_react_1.observer], ApplicationEmbed);
  return ApplicationEmbed;
}(shared_1.ComponentBase);

exports.ApplicationEmbed = ApplicationEmbed;
exports.default = shared_1.InjectedStyledComponent(ApplicationEmbed, ApplicationEmbed_meta_1.APPLICATION_EMBED_CATEGORY_KEY, ApplicationEmbed_meta_1.APPLICATION_EMBED_COMPONENT_KEY);